import React, { useEffect, useContext, useState } from "react";
import fetchContext from "../../../../contexts/fetch";
import ObjectViewer from "../../ObjectViewer";
import { IoFileTrayStackedOutline, IoReload } from "react-icons/io5";
import styles from "./logs.module.css";

const Logs = ({ callSid, collapsed, collapse }) => {
  const [fetchState, fetchDispatcher] = useContext(fetchContext);
  const [logs, setLogs] = useState({});

  useEffect(() => {
    fetchDispatcher({
      type: "fetch-callbot-simulation-logs",
      queryParameters: {
        callSid,
      },
    });
  }, [callSid]);

  const handleReloadButtonClick = () => {
    fetchDispatcher({
      type: "fetch-callbot-simulation-logs",
      queryParameters: {
        callSid,
      },
    });
  };

  useEffect(() => {
    console.log(fetchState.callbotSimulationLogs);
    if (fetchState.callbotSimulationLogs) {
      setLogs(fetchState.callbotSimulationLogs.logs);
    } else {
      setLogs({});
    }
  }, [fetchState.callbotSimulationLogs]);

  return (
    <div>
      <IoFileTrayStackedOutline
        className={styles.collapse_icon}
        onClick={collapse}
      />
      {collapsed && (
        <div className={styles.object_viewer_container}>
          {fetchState.loadingCallbotSimulationLogs && <div>Loading...</div>}
          <ObjectViewer
            object={!fetchState.loadingCallbotSimulationLogs ? logs : {}}
            title="Callbot Internal Logs"
          />
          <IoReload
            onClick={handleReloadButtonClick}
            className={styles.reload_icon}
          />
        </div>
      )}
    </div>
  );
};

export default Logs;
